// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1URRx","fullView":"styles_fullView__3vdy5"};